import React from "react";
import { NavLink } from "react-router-dom";
import Highlights from "../Component/Highlights";
import LazyLoad from "react-lazyload";
const Header = () => {
  return (
    <>
      <div className="header padded-sec">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="logo">
                <NavLink to="/">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/logo.png"
                      alt="Gayatri International School"
                      className="img-fluid"
                    />
                  </LazyLoad>
                </NavLink>
              </div>
            </div>
            <div className="col-lg-9 col-md-6">
              <div className="highlight">
                <h5>
                  <span>Announcement</span>
                </h5>
                <Highlights />
              </div>
              <div className="online-fee">
                <button className="ml-auto d-block w-auto">LOGIN</button>
              </div>
              <div className="header-nav">
                <nav className="navbar navbar-expand-lg">
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#main_nav"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                  <div className="collapse navbar-collapse" id="main_nav">
                    <ul className="navbar-nav" style={{cursor: "pointer"}}> 
                      <li className="nav-item active">
                        {" "}
                        <NavLink className="dropdown-item" to="/">
                          Home
                        </NavLink>
                      </li>
                      <li className="nav-item dropdown">
                        <div className="nav-link" data-bs-toggle="dropdown">
                          {" "}
                          School{" "}
                        </div>
                        <ul className="dropdown-menu fade-up">
                          <li>
                            <NavLink className="dropdown-item" to="/Vision">
                              Our Vision
                            </NavLink>
                          </li>
                          <li>
                            <NavLink className="dropdown-item" to="/Mission">
                              Our Mission
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              to="/ChairmanMessage"
                            >
                              Chairman's Message
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              to="/ChairpersonMessage"
                            >
                              Chairperson's Message
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              to="/AcademicHeadMessage"
                            >
                              Academic Head's Message
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              to="/PrincipalMessage"
                            >
                              Principal Message
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              to="https://www.cbse.gov.in/"
                              target="_blank"
                            >
                              CBSE Website
                            </NavLink>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown">
                        <div className="nav-link" data-bs-toggle="dropdown">
                          {" "}
                          Academics{" "}
                        </div>
                        <ul className="dropdown-menu fade-up">
                          <li>
                            <NavLink className="dropdown-item" to="/LifeatGis">
                              Life at GIS
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              to="/ExtraCurricularActivity"
                            >
                              Extra Curricular Activity
                            </NavLink>
                          </li>
                        </ul>
                      </li>
                      <li className="nav-item dropdown">
                        <div className="nav-link" data-bs-toggle="dropdown">
                          {" "}
                          Facilities{" "}
                        </div>
                        <ul className="dropdown-menu fade-up">
                          <li>
                            <NavLink
                              className="dropdown-item"
                              to="/SafetySecurity"
                            >
                              Safety & Security
                            </NavLink>
                          </li>
                          <li>
                            <NavLink className="dropdown-item" to="/Sports">
                              Sports
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              to="/Infrastructure"
                            >
                              Infrastructure
                            </NavLink>
                          </li>
                        </ul>
                      </li>

                      <li className="nav-item">
                        <NavLink className="dropdown-item" to="/Gallery">
                          {" "}
                          Gallery{" "}
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="dropdown-item" to="/Admission">
                          {" "}
                          Admission Enquiry{" "}
                        </NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink className="dropdown-item" to="/Career">
                          {" "}
                          Career Enquiry{" "}
                        </NavLink>
                      </li>
                      <li className="nav-item dropdown">
                        <div className="nav-link" data-bs-toggle="dropdown">
                          {" "}
                          Disclosure{" "}
                        </div>
                        <ul className="dropdown-menu fade-up">
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/Affiliation.pdf"
                            >
                              Affiliation Letter
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/Staff.pdf"
                            >
                              Staff Statement
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/FeeStructure.pdf"
                            >
                              Fee Structure
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/AcademicCalender.pdf"
                            >
                              Academic Calendar
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/FireSafety.pdf"
                            >
                              Fire Safety
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/CERTIFICATE_OF_LAND.pdf"
                            >
                              Land Certificate
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/NOC.pdf"
                            >
                              NOC
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/SchoolRecognition.pdf"
                            >
                              Recognition Certificate
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/Buildingsafety.pdf"
                            >
                              Building Safety Certificate
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/DrinkingwaterSanitary.pdf"
                            >
                              Valid Water,Health &amp; Sanitation Cert.
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/WATER_ANALYSIS.pdf"
                            >
                              Water Analysis Cert.
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/Society.pdf"
                            >
                              Society Certificate
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/SMC.pdf"
                            >
                              SMC
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/PTA.pdf"
                            >
                              PTA
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/Last-3-year-result.pdf"
                            >
                              Last 3 Years Result
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/Selfcertification.pdf"
                            >
                              Self Declaration
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="dropdown-item"
                              target="_blank"
                              to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/pdf/MandatoryDisclosureDetails.pdf"
                            >
                              Mandatory Disclosure{" "}
                            </NavLink>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
